export interface AgendaConfigPageData {
  href: string;
}

export interface AgendaConfigPageProps extends AgendaConfigPageData {}
